// extracted by mini-css-extract-plugin
export var currencyInput = "_lq-1";
export var currencySymbol = "_lq-0";